import styled from '@emotion/styled';

export const AvatarContainer = styled.div`
	position: relative;
	transition: all 1s ease-in-out;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	width: 10rem;
	height: 10rem;
	font-size: var(--paragraph3-font-size);
	margin: 0.5rem;

	:hover {
		.button {
			display: flex;
		}
	}

	&.circle {
		border-radius: 50%;
	}
	&.square {
		border-radius: var(--spacing-1);
	}
	&.small {
		padding: var(--padding-3);
	}
	&.medium {
		padding: var(--padding-4);
	}
	&.large {
		padding: var(--padding-5);
	}

	img {
		border-radius: inherit;
		object-fit: contain;
		cursor: pointer;
		border: none;
	}
	label {
		width: inherit;
		height: inherit;
		cursor: pointer;
		border-radius: inherit;
		border: none;
	}

	.button {
		position: absolute;
		bottom: 15%;
		left: 50%;
		transform: translateX(-50%);
		display: none;
		cursor: pointer;
		z-index: 1;
		width: 2.5rem !important;
		height: 2.5rem !important;

		animation-name: bounceAnimation;
		animation-duration: 0.3s;
		animation-timing-function: ease;

		> div {
			color: var(--alwaysWhiteColor) !important;
		}
	}

	#deleteButton {
		border: 2px solid var(--red);
		background-color: var(--red);
	}

	#uploadButton {
		border: 2px solid var(--blue);
		background-color: var(--blue);
	}

	@keyframes bounceAnimation {
		0% {
			bottom: 0%;
		}
		100% {
			bottom: 15%;
		}
	}
`;
